module.exports = __webpack_public_path__ + "img/better-beats-perfect.fbffbf63.png";